import { render, staticRenderFns } from "./entityDialogDisMenu.vue?vue&type=template&id=ed5bd558&scoped=true&"
import script from "./entityDialogDisMenu.vue?vue&type=script&lang=js&"
export * from "./entityDialogDisMenu.vue?vue&type=script&lang=js&"
import style0 from "./entityDialogDisMenu.vue?vue&type=style&index=0&id=ed5bd558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5bd558",
  null
  
)

export default component.exports